// packages/character-render/src/proceduralHumanoid.ts
//
// Box and stack part helpers shared by the humanoid body and its hats. Split
// out of proceduralHumanoid.ts.
import type { HumanoidBone, HumanoidPart } from './humanoidRig';

export type V3 = [number, number, number];

export const METAL = { metalness: 0.7, roughness: 0.35 } as const;

export function box(
  name: HumanoidPart['name'],
  color: string,
  size: V3,
  center: V3,
  style: {
    bone?: HumanoidBone;
    roughness?: number;
    metalness?: number;
    rotation?: V3;
    emissive?: string;
  } = {},
): HumanoidPart {
  const { rotation, ...surface } = style;
  return {
    name,
    voxels: [{ x: 0, y: 0, z: 0, color }],
    scale: size,
    offset: center,
    ...(rotation ? { rotation } : {}),
    ...surface,
  };
}

/** Vertical stack of equal boxes, bottom→top colours, bottom face at `baseY`. */
export function stack(
  name: HumanoidPart['name'],
  colors: readonly string[],
  size: V3,
  base: V3,
  style: { bone?: HumanoidBone; roughness?: number } = {},
): HumanoidPart {
  return {
    name,
    voxels: colors.map((color, i) => ({ x: 0, y: i, z: 0, color })),
    scale: size,
    offset: [base[0], base[1] + size[1] / 2, base[2]],
    ...style,
  };
}
